<template>
   <div>
      <div class="mainnav" v-bind:class="{ 'mainnav--active': isExpanded }">

         <div class="mainnav__trigger" v-on:click="expandmenu">
            <transition name="mainnav__trigger-text">
               <span v-if="!isExpanded">Open menu</span>
               <span v-else="">Close menu</span>
            </transition>
         </div>

         <div class="mainnav__logo" v-on:click="expandmenu">
            <router-link :to="{name: 'home'}">
               <img src="../assets/img/riley-logo-primary.png" alt="Master logo"/>
            </router-link>
         </div>
         <ul class="mainnav__links">
            <li v-on:click="expandmenu">
               <router-link :to="{name: 'home'}" @click.native="goHome">Home</router-link>
            </li>
            <li v-for="cat in category" :key="cat.id" v-on:click="expandmenu">
               <a @click='navigate(cat)'>{{ cat.navTitle }}</a>  
            </li>
         </ul>
         
         <div class="mainnav__weather">
            <span class="mainnav__weathertitle">Cairns weather</span>
            <weather api-key="ed2b5a20577e5d9e244295fe386bf28f" bar-color="#1f248a" text-color="#1e1e1e" hide-header latitude="-16.920334" longitude="145.770859" units="uk"></weather>
         </div>

      </div>
      <div class="mainnav__overlay" v-bind:class="{ 'mainnav__overlay--active': isExpanded }"></div>
      
      <div class="mainnav__back" @click=goBack>
         <span>
            <svg viewBox="0 0 448 512">
               <path d="M272 431.952v-73.798h128c26.51 0 48-21.49 48-48V201.846c0-26.51-21.49-48-48-48H272V80.057c0-42.638-51.731-64.15-81.941-33.941l-176 175.943c-18.745 18.745-18.746 49.137 0 67.882l176 175.952C220.208 496.042 272 474.675 272 431.952zM48 256L224 80v121.846h176v108.308H224V432L48 256z" class=""></path>
            </svg>
            Back
         </span>
      </div>
   </div>
</template>

<script>
   import { CATEGORIES } from '../js/categories.js';
   import VueWeatherWidget from 'vue-weather-widget';
   import 'vue-weather-widget/dist/css/vue-weather-widget.css';

   export default {
      name: 'MainNav',
      components: {
         'weather': VueWeatherWidget
      },
      data: function() {
         return {
            category: CATEGORIES,
            isExpanded: false,
         }
      },
      methods: {
         navigate (cat) {
            let params = { urlSegment: cat.urlSegment, id: cat.id }
            this.$router.push({ name: 'category', params: params })
         },
         goBack: function() {
			 if (this.currentRouteName == 'home') {
				 this.$router.go();
				 return;
			 }
			 
            this.$router.go(-1)
         },
         goHome: function() {
			 if (this.currentRouteName != 'home') {
				 this.$router.push({name: 'home'})
				 return;
			 }
			 this.$router.go();
         },
         expandmenu() {
            this.isExpanded = !this.isExpanded; 
         }
      },
		  computed: {
			currentRouteName() {
				return this.$route.name;
			}
		  }
   }
</script>
